module.exports = __webpack_public_path__ + "dc5825a0e534f5b8dc53ef9da4531bde.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanFFBlack.eot
// module id = 168
// module chunks = 0